import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-dr-mode',
  templateUrl: './dr-mode.component.html',
  styleUrls: ['./dr-mode.component.scss']
})
export class DrModeComponent implements OnInit {

  isProcessing = false;
  isDrMode: boolean = false;
  drMode: any;

  @ViewChild('drPopup', { static: true }) drPopup: TemplateRef<any>;
  visibleDrPopup: MatDialogRef<TemplateRef<any>>;

  drPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  constructor(public dialog: MatDialog, private appService: AppService, public router: Router, private snackBar: MatSnackBar,
    public paginationService: PaginationService, private route: ActivatedRoute, public message: messageService) {

  }
  ngOnInit(): void {
    this.isProcessing = true;
    this.appService.getDrMode().subscribe((data: any) => {
      this.isProcessing = false;
      if (data.length > 0) {
        this.drMode = data[0];
        this.isDrMode = this.drMode == "Y";
      }
    })
  }

  title: any;
  comments: any;
  disableDrFunc() {
    this.title = "Disable DR Mode";
    this.comments = "";
    this.visibleDrPopup = this.dialog.open(this.drPopup, this.drPopupConfig);
  }

  enableDrFunc() {
    this.title = "Enable DR Mode";
    this.comments = "";
    this.visibleDrPopup = this.dialog.open(this.drPopup, this.drPopupConfig);
  }

  messageFieldValue: any;
  messageRequiredMsg: any;
  messageOfDrModeValidation() {
    this.messageFieldValue = document.getElementById('messageOfDrMode') as HTMLInputElement;
    this.messageRequiredMsg = document.getElementById('messageOfDrMode-required-msg') as HTMLInputElement;
    if (this.comments == '') {
      this.isProcessing = false;
      this.messageFieldValue.style.border = '1px solid red';
      this.messageRequiredMsg.style.display = 'block';
    } else {
      this.messageFieldValue.style.border = 'none';
      this.messageRequiredMsg.style.display = 'none';
    }
  }

  enableOrDisableDrModeFunc() {
    this.isProcessing = true;
    if (this.isDrMode) {
      let data = {
        message: this.comments
      }
      this.appService.switchOffDrMode(data).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == 'S') {
          this.visibleDrPopup.close();
          this.isProcessing = true;
          this.appService.getDrMode().subscribe((data: any) => {
            this.isProcessing = false;
            if (data.length > 0) {
              this.drMode = data[0];
              this.isDrMode = this.drMode == "Y";
            }
          })
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });

      }, (error) => {

        this.isProcessing = false;
        throw error;
      });
    } else {
      if (this.comments == '' && !this.isDrMode) {
        this.messageOfDrModeValidation();
        this.isProcessing = false;
      } else {
        let data = {
          message: this.comments
        }
        this.appService.switchOnDrMode(data).subscribe((Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == 'S') {
            this.visibleDrPopup.close();
            this.isProcessing = true;
            this.appService.getDrMode().subscribe((data: any) => {
              this.isProcessing = false;
              if (data.length > 0) {
                this.drMode = data[0];
                this.isDrMode = this.drMode == "Y";
              }
            })
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, (error) => {

          this.isProcessing = false;
          throw error;
        });
      }
    }
  }

  cancelDRModeFunction() {
    this.visibleDrPopup.close();
  }

}
